var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysExpand = function SvgSysExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.5 17a.5.5 0 0 1 0-1h13a.5.5 0 1 1 0 1h-13Zm-3.975-2.105L1.484 12.06a.495.495 0 0 1-.159-.359.478.478 0 0 1 .147-.361l3.041-3.041a.5.5 0 0 1 .877.344.498.498 0 0 1-.17.36l-2.677 2.679 2.667 2.486a.496.496 0 0 1 .12.547.5.5 0 0 1-.805.18ZM8.499 12a.5.5 0 0 1 0-1h13a.5.5 0 1 1 0 1h-13Zm0-5a.5.5 0 0 1 0-1h13a.5.5 0 1 1 0 1h-13Z"
  })));
};
export default SvgSysExpand;